import { createContext } from 'react';

import { S3FileUploader } from '@/lib/file-uploader';

export const TicketFileUploaderContext = createContext<S3FileUploader>(null);
